import type { Config } from '@common/types/tefComs.d.ts';

// Possible "steps" in component
export enum DisplayMode {
  view = 'View',
  edit = 'Edit',
}

export const config : Config = {
  componentTagName: 'tef-coms4p',
  theme: {
    occl: {
      fonts: [
        {
          src: '/fonts/OnAir-Regular.woff2', family: 'On Air', weight: '400', style: 'normal', display: 'swap',
        },
        {
          src: '/fonts/OnAir-Bold.woff2', family: 'On Air', weight: '700', style: 'normal', display: 'swap',
        },
      ],
      resources: [
        { path: '/v3/components/theme/bundle.css' },
        { path: '/v3/components/icon/bundle.js' },
        { path: '/v3/components/modal/bundle.js' },
        { path: '/v3/library/vendors.js' },
      ],
    },
    tefOne: {
      // https://one.o9.de/main/nettokom/variables.css
      // |----theme-base-url------------|---config---------------
      resources: [
        { path: '/variables.css' },
        { path: '/components.css' },
        { path: '../bundle.js' },
      ],
    },
  },
  bugsinkDsns: {
    dev: 'https://18219f95f6424404b7810149ca73fd1f@bugsink.high.coms-dev.aws.de.pri.o2.com/6',
    prod: undefined, // 'https://f262e2800ece48d6aba51af2f53e6a96@micro-frontend-coms.telefonica.de/5'
  },
};
